<template>
  <BasePopup
    :visible="visible"
    :mask-closable="true"
    :show-close-btn="true"
    :show-confirm-btn="false"
    popup-class="join-team-popup"
    @close="handleClose"
  >
    <!-- 标题 -->
    <div class="join-team-popup-title"></div>

    <!-- 邀请模式：显示邀请文案 -->
    <div v-if="hasInviteCode" class="join-team-invite-content">
      <span class="invite-role-name">{{ inviteRoleName }}</span
      ><span class="invite-text">邀你加入TA的隊伍，請問是否接受邀請？</span>
    </div>

    <!-- 普通模式：输入区域 -->
    <div v-else class="join-team-input-wrapper">
      <div class="join-team-input-row">
        <div class="join-team-icon"></div>
        <input
          v-model="teamCode"
          type="text"
          class="join-team-input"
          placeholder=""
          maxlength="50"
          @input="clearError"
        />
      </div>
      <!-- 错误提示 -->
      <div v-if="errorMessage" class="join-team-error">{{ errorMessage }}</div>
    </div>

    <!-- 按钮组 -->
    <div class="join-team-buttons">
      <div class="join-team-btn-cancel" @click="handleCancel"></div>
      <div class="join-team-btn-confirm" @click="handleConfirm"></div>
    </div>

    <!-- 提示文字 -->
    <div class="join-team-tips">※加入隊伍後不可退出，角色等級≥45級時可參與</div>
  </BasePopup>
</template>

<script setup>
import { ref, watch } from 'vue';
import { point } from "@/utils";
import BasePopup from './BasePopup.vue';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  error: {
    type: String,
    default: ''
  },
  hasInviteCode: {
    type: Boolean,
    default: false
  },
  inviteRoleName: {
    type: String,
    default: ''
  },
  inviteCode: {
    type: String,
    default: ''
  }
});

const emit = defineEmits(['update:visible', 'close', 'confirm', 'cancel']);

const teamCode = ref('');
const errorMessage = ref('');

// 监听弹窗状态，打点上报
watch(() => props.visible, (newVisible) => {
  if (newVisible) {
    point({
      eventName: 'show_popup',
      eventType: '加入队伍弹窗'
    });
  } else {
    errorMessage.value = '';
  }
});

// 监听外部传入的邀请码
watch(() => props.inviteCode, (newCode) => {
  if (newCode) {
    teamCode.value = newCode;
  }
}, { immediate: true });

// 监听外部传入的错误信息
watch(() => props.error, (newError) => {
  errorMessage.value = newError;
});

// 清除错误提示
const clearError = () => {
  errorMessage.value = '';
};

const handleClose = () => {
  teamCode.value = '';
  errorMessage.value = '';
  emit('update:visible', false);
  emit('close');
};

const handleConfirm = () => {
  if (!teamCode.value.trim()) {
    errorMessage.value = '請輸入隊伍碼';
    return;
  }
  emit('confirm', teamCode.value);
};

const handleCancel = () => {
  teamCode.value = '';
  errorMessage.value = '';
  emit('cancel');
  emit('update:visible', false);
};
</script>

<style scoped lang="less">
</style>
